import { render, staticRenderFns } from "./MovementReport.vue?vue&type=template&id=fda3dfc8&scoped=true"
import script from "./MovementReport.vue?vue&type=script&lang=js"
export * from "./MovementReport.vue?vue&type=script&lang=js"
import style0 from "./MovementReport.vue?vue&type=style&index=0&id=fda3dfc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fda3dfc8",
  null
  
)

export default component.exports